import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueTouch from "vue-touch";
import Vant from "vant";
import { Toast } from "vant";
import "vant/lib/index.css";

Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(Toast);
Vue.use(VueTouch, { name: "v-touch" });

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
